var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("FormItem", {
    scopedSlots: _vm._u([
      {
        key: "question",
        fn: function () {
          return [_vm._v("Event details")]
        },
        proxy: true,
      },
      {
        key: "response",
        fn: function () {
          return [
            _c(
              "v-list",
              { staticClass: "pa-0" },
              _vm._l(_vm.items, function (item, idx) {
                return _c(
                  "v-list-item",
                  {
                    key: item.icon,
                    class: [_vm.$vuetify.breakpoint.smAndUp ? "px-2" : "px-0"],
                  },
                  [
                    _c(
                      "v-list-item-avatar",
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              color: "accent",
                              large: _vm.$vuetify.breakpoint.smAndUp,
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.icon) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-item-content",
                      { staticClass: "text-align-start ml-2 py-0" },
                      [
                        item.title
                          ? _c("v-list-item-title", [
                              _vm._v(_vm._s(item.title)),
                              item.autoCoupon
                                ? _c(
                                    "small",
                                    { staticClass: "line-through px-2" },
                                    [
                                      _vm._v(
                                        _vm._s(item.autoCoupon.original_amount)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.autoCoupon?.auto_coupon_amount
                          ? _c(
                              "small",
                              {
                                staticClass: "secondary--text font-weight-bold",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    `${item.autoCoupon.auto_coupon_name}! Save ${item.autoCoupon.auto_coupon_savings_format}`
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.subtitle
                          ? _c(
                              "v-list-item-subtitle",
                              {
                                ref: "subtitle",
                                refInFor: true,
                                class: item.subtitleClass,
                              },
                              [_vm._v(_vm._s(item.subtitle))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    item.action
                      ? _c(
                          "v-list-item-action",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  "x-small": "",
                                  text: "",
                                  plain: "",
                                  color: "accent",
                                  rounded: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return item.action(idx)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.toggle ? "less" : "more"))]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }